import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import SharedHeading from '../Shared/Heading/Heading';
import { Props_SnippetAccordion } from './Accordion.props';
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'


const Accordion = (props: Props_SnippetAccordion) => {
    const { heading, paragraph, repeatable_items } = props;
  const [openIndex, setOpenIndex] = useState<number>(0);

    // Extract heading values
    const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';
    const headingAlignment = heading.alignment?.value as 'start' | 'center' | 'end' || undefined;
    const headingVisibility = typeof heading.visibility?.value === 'boolean'
        ? heading.visibility.value
        : heading.visibility?.value === 'true';
    const headingText = heading.text?.value || '';

  const handleToggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? -1 : idx);
  };

    return (
        <section className="snippet-accordion">
            <span className="snippet-accordion__desktop-shape"></span>
            <div className="snippet-accordion__container">
                <div className="snippet-accordion__heading-section">
                    <SharedHeading
                        className="snippet-accordion__heading"
                        level={headingLevel}
                        visibility={headingVisibility}
                    >
                        {headingText}
                    </SharedHeading>

                    {paragraph.paragraph?.value && (
                        <div className="snippet-accordion__paragraph">
                           {CompileMarkdown(paragraph.paragraph.value)}
                        </div>
                    )}
                </div>
                <div className="snippet-accordion__content-section">
                          <div className="snippet-accordion__items">
                              {repeatable_items.map((item, idx) => (
                                  <div className="snippet-accordion__item" key={idx}>
            <button
              className={`snippet-accordion__button${openIndex === idx ? ' snippet-accordion__button--active' : ''}`}
              aria-expanded={openIndex === idx}
              aria-controls={`accordion-panel-${idx}`}
              id={`accordion-header-${idx}`}
              onClick={() => handleToggle(idx)}
              type="button"
            >
              {item.title?.value}
            </button>
                                <AnimatePresence initial={false}>
                                    {openIndex === idx && (
                                        <motion.div
                                            id={`accordion-panel-${idx}`}
                                            role="region"
                                            aria-labelledby={`accordion-header-${idx}`}
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: 'auto', opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="snippet-accordion__panel"
                                        >
                                            <div className="snippet-accordion__panel-content">{typeof item.content?.value === 'string' && CompileMarkdown(item.content.value)}</div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        ))}
                    </div></div></div>
        </section>
    );
};

export default Accordion;
